import { Tooltip } from "@/components/ui/tooltip";
import { FertSlotRequestEntity } from "@/pages/supplies-requests/fertilizer/schema/fert-slot-requests.schema";
import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import { Eye } from "lucide-react";

interface Props {
  item: FertSlotRequestEntity;
  handleDetail: (item: FertSlotRequestEntity) => void;
}

export const FertSlotRequestActions = ({ handleDetail, item }: Props) => {
  return (
    <Tooltip
      openDelay={500}
      closeDelay={100}
      positioning={{ placement: "left" }}
      content={<Text fontSize="14px">Ver detalle</Text>}
      contentProps={{
        css: {
          paddingX: "10px",
          "--tooltip-bg": AppColors.GREEN_PRIMARY,
        },
      }}
    >
      <Flex position="relative">
        <Eye
          cursor="pointer"
          onClick={() => handleDetail(item)}
          data-testid="fert-slot-request-actions-eye"
        />
      </Flex>
    </Tooltip>
  );
};
